import { createApi } from "@reduxjs/toolkit/query/react";

import { RootState } from "../@types";
import { baseQuery } from "../http/_query.http";
import { addAppMiddleware } from "../utils";

/**
 * Base API instance for NextCargo
 * All domain-specific APIs will inject their endpoints into this base API
 */
export const nextCargoApi = createApi({
  reducerPath: "nextCargo",
  baseQuery: baseQuery({
    baseUrl: import.meta.env.VITE_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const { auth: authState } = getState() as RootState;
      const driverToken = authState.driver?.accessToken;
      const expeditionToken = authState.expedition?.accessToken;
      const tokenFromState = driverToken || expeditionToken;

      const token = tokenFromState;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [
    // Auth
    "Auth",

    // Core entities
    "User",
    "Company",
    "Customer",
    "Driver",
    "DriverGroup",
    "DriverPosition",
    "Product",
    "Truck",
    "TruckSearch",
    "TruckIsTruck",
    "ShippingCompany",
    "Order",
    "Orders",
    "SearchOrders",
    "OrderHasDriver",

    // Attendances
    "Attendances",

    // Checkins
    "CheckinsActive",
    "CheckinCalled",

    // Popups
    "PopupsByCompany",
    "Popup",

    // Queue and scheduling
    "Queue",
    "Queues",
    "QueueByShippingCompany",
    "QueueDelayStatus",
    "QueueByCompany",
    "QueueDriverPositions",
    "QueueNextDateByCompany",
    "QueueRestore",
    "Scheduling",

    // Settings and configuration
    "Settings",
    "SettingsByCompany",
    "Delay",
    "Holiday",
    "HolidaysByCompany",
    "Popup",
    "UseTerm",
    "UseTermByCompany",

    // Logs and monitoring
    "Log",
    "Logs",
    "DriverLogs",
    "Objects",
    "Operations",
    "Filters",

    // Special tags for real-time updates
    "DriverCalled",
    "AttendanceCountUpdated",

    // List tags for paginated/infinite queries
    "ListCustomer",
    "ListDriver",
    "ListProduct",
    "ListTruck",
    "ListShippingCompany",
    "ListOrder",
    "ListUser",

    // List tags for Sync
    "SyncExpedition",
    "SyncTv",

    // Errors tags
    "UNKNOWN_ERROR",
    "UNAUTHORIZED"
  ],
  refetchOnReconnect: true,
  refetchOnFocus: import.meta.env.MODE === "production",
  refetchOnMountOrArgChange: 30,
  keepUnusedDataFor: 60 * 5,
  skipSchemaValidation: import.meta.env.MODE !== "development",
  endpoints: () => ({})
});
addAppMiddleware(nextCargoApi.middleware);
